import Vue from "vue";
import Router from "vue-router";
import firebase from "firebase";

const routerOptions = [
  { path: "/", component: "Landing" },
  { path: "/signin", component: "Signin" },
  { path: "/forgot_password", component: "ForgotPassword" },
  { path: "/home", component: "Home", meta: { requiresAuth: true } },
  {
    path: "/broadcasts",
    component: "Broadcasts",
    meta: { requiresAuth: true }
  },
  // { path: '/upload', component: 'Upload', meta: { requiresAuth: true } },
  { path: "/upload", component: "Upload" },
  {
    path: "/form/:formId",
    component: "Fireform",
    meta: { requiresAuth: true },
    props: true
  },
  {
    path: "/form/:formId/:docId",
    component: "Fireform",
    meta: { requiresAuth: true },
    props: true
  },
  {
    path: "/import",
    component: "DataImport",
    meta: { requiresAuth: true },
    props: true
  },

  { path: "/notfound", component: "NotFound" },
  { path: "*", component: "NotFound" }
];

const routes = routerOptions.map(route => {
  return {
    ...route,
    component: () => import(`@/components/${route.component}.vue`)
  };
});

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isAuthenticated = firebase.auth().currentUser;
  if (requiresAuth && !isAuthenticated) {
    next("/signin");
  } else {
    next();
  }
});

export default router;
